export default "__VITE_ASSET__tfF96cPP__"